import leadsConstants from "@/constants/leads";
import { LeadsPlan, LeadsState, Plans } from "@/models/LeadsState"

export const LeadsGetters = {
	PLANS_INITED: 'PLANS_INITED',
	LEADS_PLANS: 'LEADS_PLANS',
	SELECTED_PLAN: 'SELECTED_PLAN',
	IS_VALID_FOR_PAYMENT: 'IS_VALID_FOR_PAYMENT',
	CURRENT_COMPONENT: 'CURRENT_COMPONENT'
}

export default {
	[LeadsGetters.PLANS_INITED]: (state: LeadsState): boolean => {
		return !!Object.values(state.leadsPlans).length;
	},
	[LeadsGetters.LEADS_PLANS]: (state: LeadsState): Plans => {
		return state.leadsPlans;
	},
	[LeadsGetters.SELECTED_PLAN]: (state: LeadsState): LeadsPlan | undefined => {
		return state.leadsPlans[state.selectedPlanId];
	},
	[LeadsGetters.IS_VALID_FOR_PAYMENT]: (state: LeadsState, getters: any): boolean => {
		const selectedPlan = getters[LeadsGetters.SELECTED_PLAN];
		return !!selectedPlan && !!selectedPlan.price;
	},
	[LeadsGetters.CURRENT_COMPONENT]: (state: LeadsState): string => {
		return leadsConstants.STEPS_COMP[state.step];
	}
}
